import { H1, styled } from "dripsy";

export const StepHeading = styled(H1)({
  fontSize: [24, 32],
  textAlign: "center",
  mt: 0,
  mb: ["$7", "$9"],
});
